import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    container: {
      fontFamily: theme.typography.fontFamily,
      color: theme.colors.common12,
    },
    nontouchBox: {
      fontSize: '0.8rem',
    },
    topAlertIcon: {
      position: 'relative',
      fontSize: '1rem',
      top: '2px',
      paddingRight: '4px',
    },
    topAlert: {
      borderRadius: 0,
      fontSize: '0.875rem',
      backgroundColor: theme.palette.warning.main,
      padding: theme.spacing(3, 4),
      color: theme.palette.warning.contrastText,
      lineHeight: 1.5,
    },
    bodyContainer: {
      backgroundColor: theme.colorTokens.surfaceContainerLowest,
    },
    boxWrapper: {
      border: `1px solid ${theme.colorTokens.outlineVariant}`,
    },
    statusContainer: {
      backgroundColor: theme.colors.common6,
      color: theme.colorTokens.onSecondary,
      borderRadius: 0,
    },
    statusTitle: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    statusText: {
      fontSize: '15px',
      marginRight: '5px',
      verticalAlign: 'sub',
    },
    statusTextBig: {
      fontSize: '22px',
      fontWeight: 400,
      verticalAlign: 'sub',
    },
    reattemptButton: {
      color: theme.colors.common6,
      backgroundColor: theme.palette.getContrastText(theme.colors.common6),
    },
    statusProgress: {
      backgroundColor: theme.colors.common11,
      position: 'relative',
      height: '8px',
    },
    statusIndicator: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      backgroundColor: theme.colors.common7,
      color: theme.palette.getContrastText(theme.colors.common7),
      textAlign: 'center',
      position: 'relative',
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    statusInProgress: {
      position: 'absolute',
      top: -11,
    },
    statusFailed: {
      backgroundColor: theme.colors.common10,
    },
    statusCompleted: {
      backgroundColor: theme.colors.common13,
    },
    shipmentInfoContainer: {
      padding: theme.spacing(4.5),
      backgroundColor: theme.colors.common11,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
    },
    shipmentInfoLeft: {
      [theme.breakpoints.down('sm')]: {
        borderBottom: `1px solid ${theme.colors.common4}`,
        marginBottom: '20px',
      },
    },
    shipmentInfoRight: {
      paddingLeft: '10px',
      [theme.breakpoints.down('sm')]: {
        marginBottom: '20px',
        paddingLeft: 0,
      },
    },
    eventsAndMap: {
      [theme.breakpoints.up('xs')]: {
        flexDirection: 'row-reverse',
      },
    },
    button: {
      borderRadius: '40px',
      textTransform: 'initial',
      fontWeight: 600,
      boxShadow: 'none',
      display: 'inline-flex',
      alignItems: 'baseline',
    },
    tipButton: {
      marginLeft: '5px',
      marginTop: 0,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        marginTop: '10px',
      },
    },
    hideSmall: {
      [theme.breakpoints.down('sm')]: {
        display: 'none !important',
      },
    },
    showSmall: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'inline-flex',
      },
    },
    clientLogo: {
      width: '50px',
      height: '50px',
    },
    clientName: {
      fontSize: '1rem',
      marginBottom: '10px',
      color: theme.colorTokens.onSurfaceTextTitle,
    },
    grayText: {
      color: theme.colorTokens.onSurfaceTextTitle,
    },
    darkGrayText: {
      color: theme.colorTokens.onSurfaceTextTitle,
      verticalAlign: 'sub',
    },
    grayTextWithMarginBtm: {
      color: theme.colorTokens.onSurfaceTextLabel,
      marginBottom: '10px',
    },
    boldText: {
      fontWeight: 700,
      color: theme.colorTokens.onSurfaceTextTitle,
    },
    dialogButton: {
      textTransform: 'uppercase',
      minWidth: 130,
      display: 'inline-block',
      '& > .MuiButton-label': {
        display: 'inline-block',
        verticalAlign: 'sub',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: 110,
      },
    },
    bodyItemWrapper: {
      [theme.breakpoints.down('sm')]: {
        '&:first-of-type > .MuiContainer-root': {
          borderBottom: 'none',
        },
        '&:last-of-type > .MuiContainer-root': {
          borderTop: 'none',
        },
      },
    },
    bodyBottomItem: {
      backgroundColor: theme.colors.common11,
      padding: '20px',
      height: '100%',
      maxHeight: '610px',
      overflow: 'auto',
      [theme.breakpoints.down('sm')]: {
        maxHeight: 'unset',
      },
    },
    manageDeliveryContainer: {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.colorTokens.outlineVariant,
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    },
    manageDeliveryInner: {
      textAlign: 'center',
    },
    manageDeliveryLeft: theme.manageDeliveryLeft,
    mdTitle: {
      fontSize: '1.2em',
      fontWeight: 700,
    },
    mdItem: {
      verticalAlign: 'middle',
      marginRight: '5px',
    },
    whiteIcon: {
      color: theme.colors.common11,
    },
    greenIcon: {
      color: theme.palette.success.main,
    },
    redIcon: {
      color: theme.palette.error.main,
    },
    redText: {
      color: `${theme.palette.error.main} !important`,
    },
    inlineIcon: {
      verticalAlign: 'middle',
      margin: '0px 5px',
    },
    deliveryStep: {
      flexWrap: 'nowrap',
      padding: '20px 0',
      fontSize: '15px',
      color: theme.colorTokens.onSurfaceTextLabel,
      '&:first-of-type': {
        color: theme.colorTokens.onSurfaceTextTitle,
        fontWeight: 600,
      },
    },
    deliveryStepCell: {
      padding: '0 20px',
    },
    deliveryStepCellDateTime: {
      textAlign: 'right',
      maxWidth: '100px',
      [theme.breakpoints.down('md')]: {
        padding: '0 10px 0 0',
      },
    },
    deliveryStepDate: {
      fontSize: '14px',
      fontWeight: 600,
    },
    deliveryStepTime: {
      fontSize: '10px',
    },
    deliveryStepCellIcon: {
      paddingLeft: '2px',
    },
    deliveryStepConnector: {
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        left: '13px',
        width: '8px',
        minHeight: 'calc(100% + 10px)',
        backgroundColor: 'rgba(204, 204, 204, 0.4)',
      },
    },
    dialogPaper: {
      overflowScrolling: 'touch',
      WebkitOverflowScrolling: 'touch',
    },
    dialogOverlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'rgba(230, 230, 230, 0.5)',
    },
    dialogOverlayProgress: {
      position: 'absolute',
      top: '45%',
      left: '45%',
    },
    dialogMethodSelectTitle: {
      borderBottom: `1px solid #ccc`,
      borderBottomColor: theme.colors.common4,
    },
    dialogActionsWrapper: {
      padding: theme.spacing(2, 3),
      justifyContent: 'space-between',
      [theme.breakpoints.down('md')]: {
        marginBottom: '32px',
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: '160px',
      },
    },
    radioGroup: {
      '& .MuiFormControlLabel-root': {
        display: 'block',
      },
      '& .MuiFormControlLabel-root .MuiFormControlLabel-label': {
        width: 'calc(100% - 40px)',
        display: 'inline-block',
      },
      '& .MuiFormControlLabel-root .MuiFormControlLabel-label > div': {
        display: 'block',
      },
    },
    radioLabelWrapper: {
      '&:not(:last-of-type)': {
        marginBottom: '10px',
      },
      [theme.breakpoints.down('sm')]: {
        marginRight: 0,
        '&:not(:last-of-type)': {
          marginBottom: '10px',
        },
        '& .MuiFormControlLabel-label': {
          width: '100%',
        },
      },
    },
    radioLabel: {
      backgroundColor: theme.colorTokens.surfaceDim,
      borderRadius: '8px',
      padding: '15px 10px',
      display: 'inline-block',
      boxSizing: 'border-box',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
        borderRadius: '4px',
      },
    },
    codeInput: {
      width: 'fit-content !important',
      display: 'inline-block',
      '& > div > input': {
        border: 'none !important',
        borderBottom: '2px solid #ccc !important',
        borderRadius: '0 !important',
        margin: '5px',
        fontSize: '40px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '20px',
        },
      },
    },
    codeOk: {
      '& > div > input': {
        color: `${theme.palette.success.main} !important`,
        borderColor: `${theme.palette.success.main} !important`,
      },
    },
    codeWrong: {
      '& > div > input': {
        color: `${theme.palette.error.main} !important`,
        borderColor: `${theme.palette.error.main} !important`,
      },
    },
    codeStatusIcon: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    lastDialogText: {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    hint: {
      fontSize: '14px',
      marginBottom: '10px',
    },
    feedbackTitleContainer: {
      padding: theme.spacing(0, 3),
    },
    feedbackTitle: {
      position: 'relative',
    },
    feedbackTitleNoBottom: {
      position: 'relative',
    },
    feedbackContainer: {
      color: theme.colorTokens.onSurfaceTextTitle,
    },
    feedbackInput: {
      backgroundColor: theme.colors.common2,
    },
    feedbackSubmittedTime: {
      padding: theme.spacing(0, 3),
      textAlign: 'right',
    },
    selfCenter: {
      alignSelf: 'center',
    },
    separator: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      '&:after': {
        content: '',
        flex: 1,
        borderBottom: '1px solid #000',
        marginLeft: '.25em',
      },
      '&:before': {
        content: '',
        flex: 1,
        borderBottom: '1px solid #000',
        marginRight: '.25em',
      },
    },
    tippingTitleContainer: {
      padding: theme.spacing(0, 3),
    },
    tippingTitle: {
      position: 'relative',
    },
    tippingHeader: {
      display: 'inline-block',
      marginRight: '40px',
      fontWeight: 700,
      color: theme.colorTokens.onSurfaceTextHeadline,
    },
    dialogCloseButton: {
      zIndex: 2,
      position: 'absolute',
      top: -15,
      right: -20,
      [theme.breakpoints.down('sm')]: {
        top: 0,
      },
    },
    emailLabelWrapper: {
      minHeight: '41px',
    },
    sendEmailWrapper: {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'right',
      },
    },
    sendEmailBtn: {
      minWidth: theme.spacing(10),
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(1),
      },
    },
    sendEmailSuccess: {
      color: theme.palette.success.main,
    },
    underline: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    arrowIcon: {
      verticalAlign: 'bottom',
    },
    justifyContentCenter: {
      display: 'flex',
      justifyContent: 'center',
    },
    rootDialogContent: {
      overflow: 'hidden',
    },
    onSurfaceTextBody: {
      color: theme.colorTokens.onSurfaceTextBody,
    },
    onSurfaceTextLabel: {
      color: theme.colorTokens.onSurfaceTextLabel,
    },
    fontWeightBold: {
      fontWeight: 'bold',
    },
    contentText: {
      padding: '5px 0 0 0',
      marginBottom: 0,
    },
    mainContent: {
      height: '100%',
    },
    canvasWrapper: {
      height: '100%',
    },
    canvas: {
      width: '100%',
      height: '100%',
    },
    scanButton: {
      width: '100%',
      color: '#fff',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      textTransform: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    scanVisible: {
      opacity: 0.25,
    },
    submitScanButton: {
      width: '100%',
      color: '#fff',
      textTransform: 'none',
    },
    cantscanButton: {
      color: '#fff',
      width: '100%',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      bottom: theme.spacing(2),
    },
    clickSignatureLink: {
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
    },
    signTitle: {
      fontWeight: 600,
    },
    scanPreviewBox: {
      height: '200px',
      border: `1px solid ${theme.colorTokens.outlineVariant}`,
      backgroundColor: theme.colorTokens.inverseOnSurface,
      position: 'relative',
    },
    signatureImagePreview: {
      height: '100%',
      padding: '5px 0',
    },
    scanTipWrapper: {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(2),
    },
    scanTip: {
      color: '#444',
      paddingTop: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    scanTipTitle: {
      fontSize: '14px',
      fontWeight: 'bolder',
    },
    scanTipDesc: {
      fontSize: '13px',
      fontWeight: 'normal',
      paddingTop: theme.spacing(1),
    },
    signatureButton: {
      width: '100%',
      color: '#fff',
      textTransform: 'none',
    },
    signPreviewBox: {
      height: '200px',
      border: `1px solid ${theme.colorTokens.outlineVariant}`,
      backgroundColor: theme.colorTokens.inverseOnSurface,
    },
    hyperlink: {
      color: theme.colorTokens.hyperlink,
      cursor: 'pointer',
      textDecoration: 'underline',
    },
    video: {
      width: '100%',
      display: 'block',
    },
    ...theme.colorUtilities,
  };
};
